import type { CSSProperties, FC, HTMLAttributes } from 'react'
import styles from './skeleton.module.css'

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'text' | 'rectangular' | 'circular' | 'rounded'
  animation?: 'pulse' | 'wave' | false
  width?: number | string
  height?: number | string
}

export const Skeleton: FC<SkeletonProps> = ({
  variant = 'text',
  animation = 'pulse',
  width,
  height,
  className,
  style,
  ...rest
}) => {
  const classes = [
    styles.skeleton,
    variant === 'text' ? styles.text : undefined,
    variant === 'circular' ? styles.circular : undefined,
    variant === 'rounded' ? styles.rounded : undefined,
    animation === 'wave' ? styles.wave : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const computedStyle: CSSProperties = {
    ...style,
    ...(width != null ? { width } : undefined),
    ...(height != null ? { height } : undefined),
  }

  return <span className={classes} style={computedStyle} {...rest} />
}
